import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ProductsDataDownloadService } from 'src/app/services/products-data-download.service';

@Component({
  selector: 'app-products-data-download',
  templateUrl: './products-data-download.component.html',
  styleUrls: ['./products-data-download.component.css']
})
export class ProductsDataDownloadComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  orgAndProductIds:Object;
  switchTab:string = 'settings'

  @Input() set data(value) {
    
    if (value != null) {
      
      this.orgAndProductIds = {
        org_id:  value.org_id,
        product_ids: value.product_ids,
        attrs_for_table: value.attrs_for_table
      }

    }
  }

  constructor(
    public activeModal: NgbActiveModal,
    private downloadProductService: ProductsDataDownloadService
  ) { }

  ngOnInit(): void {

    this.subscriptions.add(
      this.downloadProductService.listenerSwitchTab().subscribe(val => {

        if(val){

          this.switchTab = 'settings';
        }
        
      })
    );

  }

  /**
   * 
   * @param tab 
   */
  switchTabs(tab:string){

    this.switchTab = tab;

  }
}
